export default __webpack_public_path__ + "static/media/mad-gothic01.b1b9d170.png";